export default __webpack_public_path__ + "static/media/v.cd6e846f.jpg";